const PersonalIdentificationType = {
  NZ_PASSPORT: 'NZ_PASSPORT',
  NZ_DRIVER_LICENSE: 'NZ_DRIVER_LICENSE'
};

export default PersonalIdentificationType;



/** WEBPACK FOOTER **
 ** ./src/model/PersonalIdentificationType.js
 **/